/* eslint-disable import/prefer-default-export */
/* eslint-disable no-unused-vars */
// eslint-disable-next-line import/prefer-default-export, no-shadow, no-unused-vars
enum FirestoreStatusDoc {
  Added = 'added',
  Modified = 'modified',
  Removed = 'removed'
}
export { FirestoreStatusDoc };
